export const locales = ["en", "es", "de", "fr", "it", "pl"]
export const defaultLocale = "en"
export const prefersLangToken = "__farmers-prefers-lang"
